import { ChangeChannelAction } from '../enums/action';
import { OWNER_ROLE, ROLES } from './roles';

export const CHANNEL_CUSTOMER_ACTIONS: ChangeChannelAction[] = [];

export const CHANNEL_OPERATOR_ACTIONS: ChangeChannelAction[] = [
  ...CHANNEL_CUSTOMER_ACTIONS,
  ChangeChannelAction.SET_CHANNEL_NAME,
  ChangeChannelAction.SET_CHANNEL_SHUNT_NUMBER,
  ChangeChannelAction.SET_CHANNEL_MACHINE_NUMBER,
  ChangeChannelAction.SET_CHANNEL_PHASE_NUMBER,
  ChangeChannelAction.SET_CHANNEL_CURRENT_SCALING,
  ChangeChannelAction.SET_CHANNEL_MAXIMUM_CHANNEL_TEMPERATURE,
  ChangeChannelAction.SET_CHANNEL_TRIM_CHANNEL_SETPOINT,
  ChangeChannelAction.SET_CHANNEL_POWER_SCALE,
  ChangeChannelAction.RESET_CHANNEL_SETPOINT,
  ChangeChannelAction.CLEAR_CHANNEL_SETPOINT_ADJUST,
  ChangeChannelAction.STOP_CHANNEL,
  ChangeChannelAction.START_CHANNEL,
  ChangeChannelAction.PAUSE_CHANNEL,
  ChangeChannelAction.UNPAUSE_CHANNEL,
  ChangeChannelAction.SET_CHANNEL_OUTPUT_CHANGE,
  ChangeChannelAction.RESET_CHANNEL_FAULTS,
  ChangeChannelAction.TEST_CHANNEL,
];

export const CHANNEL_SUPERVISOR_ACTIONS: ChangeChannelAction[] = [
  ...CHANNEL_OPERATOR_ACTIONS,
  ChangeChannelAction.SET_CHANNEL_TC_ASSIGN,
  ChangeChannelAction.SET_CHANNEL_TC_REMOVE,
];

export const CHANNEL_OWNER_ONLY_ACTIONS: ChangeChannelAction[] = [...CHANNEL_SUPERVISOR_ACTIONS];

export const CHANNEL_ACTIONS_BY_ROLE = {
  [OWNER_ROLE]: CHANNEL_OWNER_ONLY_ACTIONS,
  [ROLES.SUPERVISOR]: CHANNEL_SUPERVISOR_ACTIONS,
  [ROLES.OPERATOR]: CHANNEL_OPERATOR_ACTIONS,
  [ROLES.CUSTOMER]: CHANNEL_CUSTOMER_ACTIONS,
};
